import script from "./SecurityList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurityList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__